import { sort } from "lib/actions/util";
import { getRecentProjectsFromLocalStorage } from "./getRecentProjectsFromLocalStorage";

export const setAsRecentProject = (projectId: number) => {
  let recentProjects = getRecentProjectsFromLocalStorage();
  if (!recentProjects) {
    recentProjects = [];
  }
  const existingProjectIndex = recentProjects.findIndex(
    (project) => project.id === projectId,
  );
  if (existingProjectIndex !== -1) {
    recentProjects[existingProjectIndex].lastAccessed =
      new Date().toISOString();
  } else {
    recentProjects.push({
      id: projectId,
      lastAccessed: new Date().toISOString(),
    });
  }

  // sort by last accessed
  sort(recentProjects, (project) => project.lastAccessed, false);
  // only keep recent 4 projects, including current project
  recentProjects = recentProjects.slice(0, 4);

  localStorage.setItem("recentProjects", JSON.stringify(recentProjects));
};
